import Modal from '../../modal';

(function () {
  if (localStorage.getItem('splashscreen') === 'false') return;

  const splashscreen = new Modal('#splashscreen', false);
  splashscreen.openModal();

  // document.getElementById('to-link').addEventListener('click', () => closeSplashscreen());
  document.getElementById('to-site').addEventListener('click', () => closeSplashscreen());

  function closeSplashscreen() {
    splashscreen.closeModal();
    localStorage.setItem('splashscreen', 'false');
  }
})();
